export const getCurrency = (format: Intl.NumberFormat) => {
  try {
    return format?.formatToParts(1)?.find(({ type }) => type === 'currency')?.value ?? '₽';
  } catch (e) {
    return '₽';
  }
};
